import { OrderItemOptionOriginalPriceAddonsFragment } from "./original-price-addons";
import { OrderItemOptionSubtotalAddonsFragment } from "./subtotal-addons";

export const OrderItemOptionFragment = /* GraphQL */ `
	fragment OrderItemOptionFragment on OrderItemOption {
		comments
		_id
		option
		option_id
		cost
		uid
		title
		quantity
		original_price
		original_price_addons {
			...OrderItemOptionOriginalPriceAddonsFragment
		}
		listed_price
		recipe {
			raw_material
			unit_of_measurement
			consumed_unit_of_measurement
			consumed_quantity
		}
		is_hide_from_receipt
		serving_quantity
		subtotal
		subtotal_addons {
			...OrderItemOptionSubtotalAddonsFragment
		}
		net_amount
		gross_amount
		cancelled_amount
		non_sales_credit_amount
	}
	${OrderItemOptionOriginalPriceAddonsFragment}
	${OrderItemOptionSubtotalAddonsFragment}
`;
